import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const r = {
  display: "block"
}, f = ({ size: a = 16, useVw: t, useRem: n, color: o, withColor: c, removeClassName: l, disableSSR: p, style: i, ...m }) => {
  const x = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(g, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-jiegouxingchanpin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: x, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: l ? "" : "32px-ç»ææ§äº§å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: c ? d(o, 0, "#262933") : "#262933",
        datafollowfill: c ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.4 10.993a6.691 6.691 0 0 1 4.972-6.471l-.187.312a.9.9 0 0 0 1.543.926l1.14-1.898a.9.9 0 0 0-.772-1.363A8.49 8.49 0 0 0 2.6 10.993a.9.9 0 1 0 1.8 0Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.667 13.753a.8.8 0 0 1 .379 1.066l-.13.272.52.247a2.176 2.176 0 0 1-.003 3.932 2.176 2.176 0 0 1-3.048 2.482l-.52-.247-.129.272a.8.8 0 0 1-1.445-.687l.129-.272-.961-.457a1.137 1.137 0 0 1-.539-1.515l1.38-2.903h.002l.694-1.457a1.136 1.136 0 0 1 1.514-.539l.962.457.129-.272a.8.8 0 0 1 1.066-.379Zm-.405 4.073-.009-.004-2.506-1.191.495-1.04 2.508 1.192a.576.576 0 0 1-.488 1.043Zm-3.204.249-.494 1.04 2.508 1.192a.576.576 0 0 0 .502-1.036l-.006-.003-2.51-1.193Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.786 8.921A7.67 7.67 0 1 1 23.08 19.216c-.558 4.566-4.448 8.102-9.164 8.102a9.233 9.233 0 0 1-9.233-9.233c0-4.716 3.536-8.606 8.102-9.164Zm2.111-.018a5.87 5.87 0 1 1 8.201 8.201 9.247 9.247 0 0 0-8.2-8.2Zm-8.413 9.182a7.433 7.433 0 1 1 14.866 0 7.433 7.433 0 1 1-14.866 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M28.5 20.008a.9.9 0 0 1 .9.9 8.49 8.49 0 0 1-8.494 8.495.9.9 0 0 1-.772-1.363l1.14-1.899a.9.9 0 1 1 1.543.926l-.188.313a6.691 6.691 0 0 0 4.972-6.472.9.9 0 0 1 .9-.9Z"
        }
      )
    )
  )));
}, Z = f;
export {
  Z as default
};
